'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense, useState } from 'react';
import type { ReactPlayerProps } from 'react-player/types';
import dynamic from 'next/dynamic';
const ReactPlayer = dynamic(() => import('react-player'));
type VideoPlayerProps = ReactPlayerProps;
export function VideoPlayer(t0) {
  const $ = _c(11);
  let inSrc;
  let onError;
  let props;
  if ($[0] !== t0) {
    ({
      src: inSrc,
      onError,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = inSrc;
    $[2] = onError;
    $[3] = props;
  } else {
    inSrc = $[1];
    onError = $[2];
    props = $[3];
  }
  const [retryAttempt, setRetryAttempt] = useState(0);
  const [src, setSrc] = useState(inSrc);
  let t1;
  if ($[4] !== onError || $[5] !== retryAttempt) {
    t1 = e => {
      onError?.(e);
      if (retryAttempt < 3) {
        setRetryAttempt(_temp);
        setSrc(src_0 => {
          if (!src_0) {
            return src_0;
          }
          const srcUrl = new URL(src_0);
          srcUrl.searchParams.set("retry", retryAttempt.toString());
          return srcUrl.toString();
        });
      }
    };
    $[4] = onError;
    $[5] = retryAttempt;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleError = t1;
  let t2;
  if ($[7] !== handleError || $[8] !== props || $[9] !== src) {
    t2 = <Suspense><ReactPlayer src={src} onError={handleError} {...props} /></Suspense>;
    $[7] = handleError;
    $[8] = props;
    $[9] = src;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}
function _temp(prev) {
  return prev + 1;
}